/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x2e286a from'./../../message.js';class GetManyUsersMessage extends _0x2e286a{constructor(_0x5a1057){super(),this['ids']=_0x5a1057;}['toJSON'](){return{'ids':this['ids']};}static['fromJSON'](_0x59411d){return new GetManyUsersMessage(_0x59411d['ids']);}}GetManyUsersMessage['TYPE']='22',GetManyUsersMessage['READABLE_TYPE_NAME']='getManyUsers',GetManyUsersMessage['DESCRIPTOR_NAME']='GetManyUsersMessage',GetManyUsersMessage['DESCRIPTOR']={'fields':{'ids':{'id':0x1,'type':'string','rule':'repeated'}}};export default GetManyUsersMessage;